// Keeps a jersey line and its "Flocage personnalisé" fee line locked together in the
// cart, everywhere the cart can change (cart page, cart drawer, cart notification).
// Both lines carry the same hidden _flocage_link property (a unique id generated at
// add-to-cart time), so each jersey/fee pair is tracked independently — buying several
// personalized jerseys creates several independent pairs.
//
// The sync is bidirectional: removing either line of a pair removes the other. This
// closes the loophole where a customer could delete only the "Flocage personnalisé"
// line and keep a personalized jersey without paying the surcharge.
//
// The paired removal below always requests the cart's own AJAX "sections" (exactly
// what cart.js's updateQuantity does for a normal remove-button click) and repaints
// them itself, so the subtotal, total, item count and line list are all recalculated
// and re-rendered immediately — not just the removed line disappearing while the
// totals stay stale until the next page action.
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function linkOf(item) {
    return item.properties && item.properties['_flocage_link'];
  }

  // Any line carrying a _flocage_link with no other line sharing that same link is
  // orphaned — whichever of the two lines the customer removed, the survivor gets
  // swept here. Since the cart-items.js update that triggered this event already
  // reflects the removed line's absence, a single pass is enough (no recursion
  // needed: a pair only ever links exactly two lines).
  function findOrphanedLines(items) {
    return items.filter((item) => {
      const link = linkOf(item);
      if (!link) return false;
      return !items.some((other) => other !== item && linkOf(other) === link);
    });
  }

  function getCartItemsElement() {
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  // Repaints every section cart.js itself would repaint after a normal remove-button
  // click (main-cart-items/main-cart-footer/cart-icon-bubble on the cart page, or the
  // drawer's own sections) — the same AJAX cart mechanism Dawn already uses.
  function renderSections(cartItemsEl, parsedState) {
    if (!cartItemsEl || typeof cartItemsEl.getSectionsToRender !== 'function') return;

    cartItemsEl.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container || !parsedState.sections || !parsedState.sections[section.section]) return;

      const elementToReplace = (section.selector && container.querySelector(section.selector)) || container;
      elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });

    const isEmpty = parsedState.item_count === 0;
    cartItemsEl.classList.toggle('is-empty', isEmpty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', isEmpty);
  }

  function removeLine(item, cartItemsEl) {
    const body = { id: item.key, quantity: 0, sections_url: window.location.pathname };

    if (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') {
      body.sections = cartItemsEl.getSectionsToRender().map((section) => section.section);
    }

    return fetch(routes.cart_change_url, { ...fetchConfig(), body: JSON.stringify(body) })
      .then((response) => response.json())
      .catch((error) => {
        console.error('FootKit : impossible de synchroniser la paire maillot/flocage dans le panier', error);
        return null;
      });
  }

  // Removed sequentially (not in parallel) so each request's response reflects the
  // cart state left by the previous one — the final response is always accurate.
  function removeLinesSequentially(items, cartItemsEl) {
    return items.reduce(
      (chain, item) => chain.then((lastState) => removeLine(item, cartItemsEl).then((state) => state || lastState)),
      Promise.resolve(null)
    );
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'cart-items') return;

    const items = event.cartData && event.cartData.items;
    if (!Array.isArray(items)) return;

    const orphans = findOrphanedLines(items);
    if (!orphans.length) return;

    const cartItemsEl = getCartItemsElement();

    removeLinesSequentially(orphans, cartItemsEl).then((finalState) => {
      if (!finalState) return;
      renderSections(cartItemsEl, finalState);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-flocage-sync', cartData: finalState });
    });
  });
})();
